// Copyright 2026, Common Good Learning Tools LLC
import { mapState, mapGetters } from 'vuex'

export default {

	data() { return {
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),
	},
	watch: {
	},
	methods: {
		async export_nc_ai(base_type = 'Standard') {
			let rows = [
				// header row
				[
					'case_framework_identifier',
					'case_item_identifier',
					'code',					// lowest-level humanCodingScheme for this row
					'grade_band',			// educationLevel (range)
					'strand_domain',		// level above standard
					'standard_code',		// standard humanCodingScheme
					'standard_statement',	// standard fullStatement
					'objective_code',		// objective humanCodingScheme (if included)
					'objective_statement',	// objective fullStatement (if included)
				]
			]

			let record_row = (grandparent_item, base_item, child_item) => {
				let main_item = child_item || base_item
				rows.push([
					// case_framework_identifier
					this.framework_record.lsdoc_identifier,
					// case_item_identifier
					main_item.identifier,
					// code -> lowest-level humanCodingScheme for this row
					main_item.humanCodingScheme || '',
					// grade_band -> educationLevel (range)
					U.grade_level_display(main_item.educationLevel, this.framework_record?.resolved_grades),
					// strand_domain -> level above standard
					grandparent_item?.fullStatement || '',
					// standard_code -> standard humanCodingScheme
					base_item.humanCodingScheme || '',
					// standard_statement - standard fullStatement
					base_item.fullStatement,
					// objective_code -> objective humanCodingScheme (if included)
					child_item?.humanCodingScheme || '',
					// objective_statement -> objective fullStatement (if included)
					child_item?.fullStatement || '',
				])
			}

			let export_nc_ai_recurse = (node, previous_item) => {
				// if this node is the base_type...
				if (U.item_type_string(node.cfitem) == base_type) {
					// record a row for the base item
					record_row(previous_item, node.cfitem, null)

					// and record rows for any children
					for (let child_node of node.children) {
						record_row(previous_item, node.cfitem, child_node.cfitem)
					}
				
				// else recurse for each child of this node
				} else {
					for (let child_node of node.children) {
						export_nc_ai_recurse(child_node, node.cfitem)
					}
				}
			}

			// start recursing from currently-selected branch (could be the document)
			let starting_node = this.framework_record.cfo.tree_nodes_hash[this.active_node]
			export_nc_ai_recurse(starting_node, null)
			console.log(rows)

			let title = 'Export to NCDPI AI Spreadsheet Format (CSV)'
			let text = ''
				+ `<div class="mb-1">Top ancestor item: <b>${starting_node.cfitem.fullStatement || starting_node.cfitem.title}</b></div>`
				+ `<div class="mb-3">Base item type: <b>${base_type}</b></div>`
				+ `<div class="mb-1">Sample rows:</div>`
				+ `<textarea style="border: 1px solid rgb(0, 0, 0); width:100%; height:74px; padding:4px; white-space:nowrap;">`
				+ (empty(rows[1]) ? '' : rows[1].map(val => `"${val}"`).join(', ')) + '\n'
				+ (empty(rows[2]) ? '' : rows[2].map(val => `"${val}"`).join(', ')) + '\n'
				+ (empty(rows[3]) ? '' : rows[3].map(val => `"${val}"`).join(', ')) + '\n'
				+ `</textarea>`
				+ `<div class="mt-3">Click EXPORT to download a CSV file with <b>${rows.length-1} rows</b></div>`
				+ `<div class="mt-3 mb-2">Or choose a different base item type and click REPROCESS.</div>`
			console.log(text)

			let val = await U.prompt_promise({
				title,
				text,
				promptType: 'select',
				selectOptions: this.framework_record.cfo.item_types,
				initialValue: base_type,

				extraBtnText: 'Export',
				extraBtnIcon: 'fas fa-file-arrow-down',
				extraBtnColor: 'green darken-3',
				acceptText: 'Change Base Type',
				acceptIconAfter: 'fas fa-recycle',
				acceptColor: 'orange darken-3',
				cancelText: 'Cancel',
				cancelIcon: 'fas fa-xmark',
				dialogMaxWidth: 800,
			})

			// if user clicks cancel, bail out
			if (val === false) {
				return

			// if user clicks extra btn (EXPORT), save
			} else if (val === 'extra') {
				let date_string = date.format(new Date(), 'YYYY-MM-DD')
				let filename = `${this.framework_record.json.CFDocument.title}-NCDPI-AI-EXPORT-${date_string}.csv`
				U.download_file(CSV.stringify(rows), filename)
				return

			// user clicked accept btn (CHANGE), so re-process with chosen type
			} else {
				console.warn(val)
				this.export_nc_ai(val)
			}
		},
	}
}